import config from "../../config";
import axios from "axios/index";
import appErrorLogger from "../common/DataDogErrorLog";
import appInfoLogger from "../common/DataDogInfoLog";
import {setUserProfile} from "./myAccountAC";
import underscore from "underscore";
import { setShopifyFavorites } from "./shopifyAC";
import _ from "underscore";
import {
    authCheck, canSeeFirstLook, checkUTMParams,
    clearTradeItemsFromSession, deleteAllSearchParams, deleteCookie,
    filterBannersByTier, getCookie,
    getTierByTierKey, setCookie, validateEmail,
    vipPreviewTimers,
} from "../common/utils";
import {isBetweenDates} from "../common/utils";
import {v4} from "uuid";
import flagsmith from "flagsmith"
import { getLocalCartId, mergeShopifyCartItems, setShopifyCart } from "./cart"

const authenticatedAxios = () => {
    const auth_token = getCookie('auth_token');
    return axios.create({
        baseURL: `${config.host_rebag_api}/v6/`,
        timeout: 15000,
        headers: {'Authorization': auth_token}
    });
};

const now = new Date();
const requestPerHrPerDay = `${now.getDate()}-${now.getHours()}`;

const getPromoBanners = () => {
    return (dispatch, getState) => {
        axios.get(`${config.host_rebag_api}/v6/get-banners/?${requestPerHrPerDay}`)
            .then((response) => {
                let banners = [];
                if(authCheck()){
                    const my_account_reducer = getState().myAccountReducer;
                    const {user_profile} = my_account_reducer;
                    const current_tier = user_profile ? getTierByTierKey(user_profile.tier.tier_key) : null;
                    const can_see_first_look = canSeeFirstLook(user_profile);

                    // Add VIP Preview banner
                    const {
                        vip_preview_ends_at, vip_preview_duration, must_show_generic_message, must_show_vip_message
                    } = vipPreviewTimers();

                    if(can_see_first_look && must_show_generic_message){
                        if(must_show_vip_message){
                            banners.push({
                                can_dismiss: false,
                                countdown_prefix: "expires in: ",
                                description: "",
                                end_date: vip_preview_ends_at.toISOString(),
                                show_countdown: true,
                                title: "EXCLUSIVE | Your VIP Preview of New Arrivals",
                            });
                        } else {
                            banners.push({
                                can_dismiss: false,
                                countdown_prefix: "",
                                description: "",
                                end_date: "",
                                show_countdown: false,
                                title: `EXCLUSIVE | Your ${vip_preview_duration}-hour VIP Preview of New Arrivals starts tomorrow`
                            });
                        }
                    }

                    // Filter banners by tier
                    banners.push(...filterBannersByTier(response.data, current_tier ? current_tier.rank : 0));

                    // Add special discount banner
                    const special_discount = user_profile && user_profile.tier && user_profile.tier.special_discount;
                    if(special_discount){
                        banners.push({
                            can_dismiss: false,
                            countdown_prefix: "Expires in: ",
                            description: '',
                            end_date: special_discount.expiration_date,
                            show_countdown: false,
                            title: `Get ${parseInt(special_discount.percentage)*-1}% off with your Special Day Discount Code ${special_discount.code}`
                        });
                    }
                } else {
                    banners.push(...filterBannersByTier(response.data, 0));
                }

                const is_from_paid_campaign = checkUTMParams();

                banners = _.filter(banners, (banner) => {
                    if (is_from_paid_campaign) {
                        return banner.is_paid_promo || !banner.is_paid_promo;
                    } else {
                        return !banner.is_paid_promo;
                    }
                });

                dispatch({
                    type: "SET_PROMO_BANNERS",
                    promo_banners: banners
                })
            })
            .catch(function (error) {
                appErrorLogger('Get promo banners', error);
            });
    }
}

const getPromoMessages = () => {
    return (dispatch, getState) => {
        axios.get(`${config.host_rebag_api}/v6/shop/promo-message/`)
            .then((response) => {
                dispatch({
                    type: "SET_PROMO_MESSAGING",
                    promo_messages: response.data
                })
            })
          .catch((error) => {
              appErrorLogger('Get promo messages', error);
          })
    }
}

const filterPromoMessages = (promo_messages, product_tags = [], source = 'show_in_pdp') => {
    const is_from_paid_campaign = checkUTMParams();
    let is_b2b = false;
    let current_tier = 0;
    let special_discount = null;
    let user_profile = {};
    if(authCheck()){
        user_profile = JSON.parse(localStorage.getItem('user_profile'));
        is_b2b = user_profile && user_profile.is_b2b;
        const tier = user_profile ? user_profile.tier : null;
        special_discount = tier && tier.special_discount;
        current_tier = tier && getTierByTierKey(tier.tier_key);
    }

    const my_promo_messages = _.chain(promo_messages)
        .filter((promo_message) => {
            return ('show_in_pdp' === source && promo_message.show_in_pdp) || ('show_in_plp' === source && promo_message.show_in_plp) || ('show_in_cart' === source && promo_message.show_in_cart);
        })
        .filter((promo_message) => {
            const rank = current_tier ? current_tier.rank : 0;
            return (promo_message.applies_only_to_selected_tier && promo_message.tier === rank) || (!promo_message.applies_only_to_selected_tier && rank >= promo_message.tier);
        })
        .filter((promo_message) => {
            if(promo_message.is_b2b){
                return is_b2b;
            } else {
                return true;
            }
        })
        .filter((promo_message) => {
            if(is_from_paid_campaign){
                return promo_message.is_paid_promo;
            } else {
                return !promo_message.is_paid_promo;
            }
        })
        .filter((promo_message) => {
            return isBetweenDates(promo_message.start_date, promo_message.end_date);
        })
        .filter((promo_message) => {
            if(promo_message.tag){
                const isCollectionSale = _.filter(product_tags, (tag) => {
                    return tag?.toLowerCase() === promo_message.tag.toLowerCase();
                }).length === 1;
                return isCollectionSale;
            } else {
                return true;
            }
        })
        .map((promo_message) => {
            return promo_message;
        })
        .reduce((max, current) => {
            return current.discount_percentage > max.discount_percentage ? current : max;
        })
        .value();

    let next_promo_messages = my_promo_messages && [my_promo_messages];
    const has_sitewide_tag = _.find(product_tags, (product_tag) => {
        return "sitewideselect" === product_tag;
    });
    if(special_discount && 'show_in_pdp' === source && has_sitewide_tag) {
        next_promo_messages.push({
            message: `EXPIRES 5/6: Get ${special_discount.percentage ? parseInt(special_discount.percentage)*-1 : ""}% off with your Special Day Discount.<br/> Code: <strong>${special_discount.code}</strong>`,
            discount_code: special_discount.code,
        });
    }

    return next_promo_messages;
}
window.filterPromoMessages = filterPromoMessages;

const noScroll = (state) => {
    return (dispatch, _) => {
        dispatch({
            type: "NO_SCROLL",
            no_scroll: state
        })
    }
};

const getMobileBp = () => {
    return (dispatch, getState) => {
        const {mobile5s, mobile_small, mobile_medium, mobile_big, desktop_small, desktop_big} = getState().appReducer;
        if (mobile5s !== window.innerWidth <= 320 || mobile_small !== window.innerWidth < 544 || mobile_medium !== window.innerWidth < 768 || mobile_big !== window.innerWidth < 992 || desktop_small !== window.innerWidth < 1300 || desktop_big !== window.innerWidth >= 1300) {
            dispatch({
                type: "MOBILE_BREAKPOINTS",
                mobile5s: window.innerWidth <= 320 ? true : false,
                mobile_small: window.innerWidth < 544 ? true : false,
                mobile_medium: window.innerWidth < 768 ? true : false,
                mobile_big: window.innerWidth < 992 ? true : false,
                desktop_small: window.innerWidth < 1300 ? true : false,
                desktop_big: window.innerWidth >= 1300 ? true : false,
            })
        }
    }
};

const openLoginModal = (login_type) => {
    return (dispatch, _) => {
        dispatch({
            type: "OPEN_LOGIN_MODAL",
            login_type: login_type,
            modal_opened: true,
            dismiss_able: true
        })
    }
};

const closeLoginModal = () => {
    return (dispatch, getState) => {
        if(authCheck() && _.isFunction(window.next_action)){
            window.next_action();
        }
        delete(window.next_action);

        dispatch({
            type: "CLOSE_LOGIN_MODAL",
            modal_opened: false
        })

        if (document.getElementById("add-to-cart-button-input")) {
            document.getElementById("add-to-cart-button-input").classList.remove("pdp__cart-cta--disabled");
        }
    }
};

const userLoggedIn = (isSocialLogin) => {
    return (dispatch) => {
        dispatch({
            type: "USER_IS_LOGGED_IN"
        });
        if (isSocialLogin) dispatch(setUserProfile());
        deleteCookie("newsletter_modal_open");
        setCookie("newsletter_modal_closed", '1');
    }
};

const userLoggedOut = () => {
    return (dispatch, _) => {
        dispatch({
            type: "USER_IS_LOGGED_OUT",
            user_logged_in: false
        })
    }
};

const showSpinner = () => {
    return (dispatch, _) => {
        dispatch({type: "SHOW_SPINNER"});
    }
};

const hideSpinner = () => {
    return (dispatch, _) => {
        dispatch({type: "HIDE_SPINNER"});
    }
};

const showModalSpinner = () => {
    return (dispatch, _) => {
        dispatch({type: "SHOW_MODAL_SPINNER"});
    }
}

const hideModalSpinner = () => {
    return (dispatch, _) => {
        dispatch({type: "HIDE_MODAL_SPINNER"});
    }
}

const signupSuccess = (success_signup) => {
    return (dispatch, _) => {
        dispatch({
            type: "SIGNUP_SUCCESS",
            success_signup: success_signup,
            modal_opened: false
        });
    }
}

const trackDataEvents = (payload, alternate_id = v4()) => {
    const {ga_event} = payload;
    const next_payload = {
        ...payload,
        'alternate_id': alternate_id,
        'source_url': window.location.href,
        'gclid': getCookie('gclid') || null,
        'ttclid': getCookie('ttclid') || null,
        //ga_client_id: GA1.2.657987244.1670347773
        'ga_client_id': getCookie('_ga') || null,
        'ga_user_id': null,
        'fbp': getCookie('_fbp') || null,
        'fbc': getCookie('_fbc') || null,
    }
    const next_ga_event = ga_event ? ga_event : {
        'event': payload.event_type,
        ...payload.event_properties
    }
    try {
        window.dataLayer.push({
            ...next_ga_event,
            'alternate_id': alternate_id,
        })
    } catch (error) {
        appErrorLogger('Simon data events GA', error);
    }

    authenticatedAxios().post(`${config.host_rebag_api}/v6/track/event/`, next_payload, { withCredentials: true })
        .catch((error) => {
            appErrorLogger('Track data events', error);
        })
}
window.trackDataEvents = trackDataEvents;

const newsletterSignup = (email, phone, suppress_newsletter_modal) => {
    return (dispatch, _) => {
        if (validateEmail(email)) {
            axios.post(`${config.host_rebag_api}/trendlee/subscribe/`, {
                email: email,
                phone: phone
            }).then((response) => {
                try {
                    window.userEmail = email;
                    window.dataLayer.push({
                        'event': 'NLModalSubscribe',
                        'phone': phone
                    });
                } catch (error) {
                    appErrorLogger('NLModalSubscribe GTM', error);
                }
                dispatch({
                    type: "NEWSLETTER_SUCCESS",
                    success_signup: true,
                    modal_opened: false,
                    suppress_newsletter_modal: suppress_newsletter_modal
                });
            }).catch((error) => {
                appErrorLogger("Newsletter Signup", error, {userEmail: email});
                window.dataLayer.push({
                    'event': 'NLModalSubscribe',
                    'phone': phone
                });
                dispatch({
                    type: "NEWSLETTER_SUCCESS",
                    success_signup: true,
                    modal_opened: false,
                    suppress_newsletter_modal: suppress_newsletter_modal
                });
            })
        } else {
            appInfoLogger('Newsletter Signup Invalid Email', { message: email });
        }
    }
}

const getVaultItems = () => {
    return (dispatch, _) => {
        axios.get(`${config.host_rebag_vault}/feed/json`)
            .then((response) => {
                dispatch({
                    type: "GET_VAULT_ITEMS",
                    vault_articles: response.data
                });
            })
            .catch((error) => appErrorLogger('Get Vault Items', error))
    }
}

const getHomeDataDetails = () => {
    return (dispatch, _) => {
        axios.get(`${config.host_rebag_api}/v6/home-data-details/`)
            .then((response) => {
              dispatch({
            type: "HOME_DATA_DETAILS",
            home_details: response.data
        });
            })
            .catch(function (error) {
                appErrorLogger('Get home data details', error);
            });
    }
};

const getShopifyDataFromFavoriteList = () => {
    return (dispatch, getState) => {
        const userFavorites = getState().myAccountReducer.user_profile?.favorites;
        if(userFavorites && userFavorites.length > 0){
            const shop_prefix = "gid://shopify/Product/";
            const product_ids = underscore.map(userFavorites.slice(0, 15), (product) => {
                return btoa(shop_prefix + product);
            })
            dispatch(setShopifyFavorites(product_ids));
        }
    }
};

const getForYouHomepageData = () => {
    return (dispatch, _) => {
        authenticatedAxios().get(`${config.host_rebag_api}/v6/meta/for-you-homepage/`)
            .then((response) => {
                dispatch({
                    type: "GET_FOR_YOU_PRODUCTS_HOMEPAGE",
                    for_you_products_homepage: response.data
                });
            })
            .catch(function (error) {
                appErrorLogger('Get For You Collections', error);
            });
    }
}

const forceLogout = () => {
    deleteCookie("auth_email");
    deleteCookie("auth_token");
    deleteCookie("is_b2b");
    deleteCookie("checkout_id");
    deleteCookie("second_fa_token");
    deleteCookie("can_see_first_look");
    deleteCookie("user_hash");
    deleteCookie('checkoutUrl');
    deleteCookie('cartId');
    deleteCookie('tradeAndSubscriptionApplied');
    sessionStorage.removeItem("selected_shipping_address_id");
    sessionStorage.removeItem("selected_billing_address_id");
    localStorage.removeItem("user_profile");

    clearTradeItemsFromSession();
}

const logout = () => {
    return (dispatch, _) => {
        axios.get(`${config.host_rebag_api}/v6/logout`, { withCredentials: true })
            .then(() => {
                SocialLogout();
            })
            .then(() => {
                forceLogout();
            })
            .then(() => {
                window.rebagHeader.reactAuthVisual(null);
            })
            .then(() => {
                const location = new URL(window.location);
                const hostname = `${location.protocol}//${location.hostname}`;

                if(hostname === config.host_rebag_shop){
                    axios.get(`${config.host_rebag_shop}/account/logout`).then(() => {
                        deleteAllSearchParams();
                        let next_location = window.location.href;
                        if(config.preview_theme_id){
                            next_location += ((window.location.search.indexOf('?') > -1) ? '&' : '?') + config.preview_theme_id;
                        }
                        window.location = next_location;
                        // window.location.reload();
                    }).catch(function (error) {
                        appErrorLogger('Unable to logout shop', error);
                    });
                } else {
                    deleteAllSearchParams();
                    window.location = `${config.host_rebag}/logout`;
                }
            })
            .catch(function (error) {
                appErrorLogger('Unable to logout', error);
            });
    }
}

const renderLogoutPopup = (logout_modal_settings) => {
    return (dispatch, _) => {
        // if(callback){
        //     window.next_action = callback;
        // }
        dispatch({
            type: "OPEN_LOGOUT_MODAL",
            logout_modal_settings: logout_modal_settings
        });
    }
}

const dismissLogoutPopup = () => {
    return (dispatch, _) => {
        dispatch({
            type: 'DISMISS_LOGOUT_MODAL',
        })
        dispatch({
            type: "NO_SCROLL",
            no_scroll: false,
        })
    }
}

const isMobile = {
    Android: function() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};

const socialError = (social_error) => {
    return (dispatch, _) => {
        dispatch({
            type: "SOCIAL_ERROR",
            social_error: social_error
        });
    }
}

function socialLogin(newsletter = false) {
    return (dispatch, _) => {
        deleteCookie("fblo_" + config.rebag_fb_app_id);

        window.FB.init({
            appId      : config.rebag_fb_app_id,
            cookie     : true,
            xfbml      : true,
            version    : 'v22.0'
        });

        window.FB.login(function (response) {
            if (response && response.status === 'connected') {
                const auth_data = response.authResponse;
                window.FB.api('/me?fields=id,name,email', function(response) {
                    if(response.email) {
                        const location = new URL(window.location);
                        const hostname = `${location.protocol}//${location.hostname}`;
                        const urlParams = new URLSearchParams(window.location.search);

                        const data = new FormData();
                        data.append("provider", "facebook_rebagg");
                        data.append("email", response.email);
                        data.append("access_token", auth_data.accessToken);
                        data.append("uid", response.id);
                        data.append("name", response.name);
                        data.append("user_uses_ios", !!isMobile.iOS() ? "true" : "false");
                        data.append("user_uses_android", !!isMobile.Android() ? "true" : "false");
                        data.append("user_uses_web", !isMobile.iOS() && !isMobile.Android() ? "true" : "false");
                        data.append("sign_up_checkbox", newsletter ? "true" : "false");

                        axios.post(`${config.host_rebag_api}/v6/social_login`, data, {withCredentials: true})
                            .then(async (response) => {
                                const {multipass_url, auth_token, user, error} = response.data;
                                if (error) {
                                    window.rebagHeader.reactLoginError(error.message);
                                } else {
                                    const userEmail = user.email;
                                    const authToken = `Token ${auth_token}`;
                                    try {
                                        window.userEmail = userEmail;
                                    } catch (error) {
                                        appErrorLogger('userEmail GTM', error);
                                    }

                                    setCookie('auth_email', userEmail);
                                    setCookie('auth_token', authToken);
                                    if(getLocalCartId()){
                                       await dispatch(mergeShopifyCartItems());
                                    } else {
                                        dispatch(setShopifyCart())
                                    }

                                    window.dataLayer.push({
                                        'event': 'loginFacebook',
                                    });

                                    if (hostname === config.host_rebag_shop) {
                                        axios.get(multipass_url, {withCredentials: true})
                                            .then(() => {
                                                window.rebagHeader.reactAuthVisual(user, true);
                                            })
                                            .catch((error) => {
                                                appErrorLogger('Unable to social login with multipass', error);
                                            })
                                        ;
                                    } else {
                                        window.rebagHeader.reactAuthVisual(user, true);
                                        if(urlParams.has('next')){
                                            window.location = hostname + urlParams.get('next');
                                        }
                                    }
                                }
                            })
                            .catch(function (error) {
                                window.rebagHeader.reactLoginError("Something went wrong, please try again later.");
                                appErrorLogger('Unable to social login', error);
                            });
                    } else {
                        dispatch(socialError(true));
                    }
                });
            } else {
                window.rebagHeader.reactLoginError('Please log into Facebook!');
            }
        }, {
            scope: 'email, public_profile'
        });
    }
}

function SocialLogout() {
    window.FB.getLoginStatus(function(response) {
        if (response.status === 'connected') {
            window.FB.logout();
        }
    });
}

const login = (email, password, from_ty_page = false, gc_token = null) => {
    return (dispatch) => {
        const data = {
            "username": email,
            "password": password,
            "user_uses_ios": !!isMobile.iOS(),
            "user_uses_android": !!isMobile.Android(),
            "user_uses_web": !isMobile.iOS() && !isMobile.Android(),
            "gc_token": gc_token
        };

        deleteCookie("second_fa_token");

        axios.post(`${config.host_rebag_api}/v7/login`, data, { withCredentials: true })
            .then(async (response) => {
                const {is_authenticated, error} = response.data;
                if(!is_authenticated && error) {
                    window.rebagHeader.reactLoginError(error.message);
                } else {
                    await dispatch(thingsToDoAfterLogin(response.data, gc_token, from_ty_page));
                }
            })
            .catch(function (error) {
                window.rebagHeader.reactLoginError("Something went wrong, please try again later.");
                appErrorLogger('Login with Django failed', error);
            });
    }
}

const signup = (email, password, gc_token = null) => {
    return (dispatch, _) => {
        const location = new URL(window.location);
        const urlParams = new URLSearchParams(location.search);
        const data = {
            "email": email,
            "password": password,
            "user_initial_url_before_acct_creation": getCookie('user_initial_url_before_acct_creation'),
            "user_last_url_before_acct_creation": urlParams.get('next') || null,
            "user_account_creation": Date.now(),
            "user_ga_source": getCookie('rbg_utm_source'),
            "user_ga_medium": getCookie('rbg_utm_medium'),
            "user_ga_campaign": getCookie('rbg_utm_campaign'),
            "user_uses_ios": !!isMobile.iOS(),
            "user_uses_android": !!isMobile.Android(),
            "user_uses_web": !isMobile.iOS() && !isMobile.Android(),
            "gc_token": gc_token
        };

        axios.post(`${config.host_rebag_api}/v7/create-account`, data, {withCredentials: true})
            .then(async (response) => {
                window.dataLayer.push({
                    'event': 'signupsuccess',
                })
                const {is_authenticated, error} = response.data;
                if (!is_authenticated && error) {
                    window.rebagHeader.reactLoginError(error.message);
                } else {
                    trackDataEvents({
                        "event_type": "registration",
                        "event_properties": {
                            'email': response.data.user.email
                        },
                        'ga_event': {
                            'event': 'registration',
                        }
                    })
                    //set cookie so we display the finalize signup modal
                    setCookie('new_account', '1');
                    // We need true to trigger setAuthenticatedCheckout not mergeShopifyCartItems when signup
                    await dispatch(thingsToDoAfterLogin(response.data, gc_token));
                }
            })
            .catch((error) => {
                if(error.response.status === 403){
                    dispatch(closeLoginModal());
                    dispatch({
                        type: 'TOGGLE_EMAIL_CONFIRMATION',
                        toggle: true
                    })
                } else {
                    window.rebagHeader.reactLoginError("Something went wrong, please try again later.");
                    appErrorLogger('Signup with Django failed', error);
                }
            });
    }
}

const thingsToDoAfterLogin = (apiObject, gc_token, fromTyPage) => (dispatch) => {
    return new Promise (async (resolve) => {
        const {auth_token, user, multipass_url, is_valid_phone, user_hash} = apiObject;
        const userEmail = user.email;
        const authToken = `Token ${auth_token}`;
        const location = new URL(window.location);
        const hostname = `${location.protocol}//${location.hostname}`;
        const urlParams = new URLSearchParams(window.location.search);
        try {
            window.userEmail = userEmail;
        } catch (error) {
            appErrorLogger('userEmail GTM', error);
        }

        setCookie('auth_email', userEmail);
        setCookie('auth_token', authToken);
        setCookie("user_hash", user_hash);

        if(is_valid_phone){
            sessionStorage.setItem('is_valid_phone', '1');
        }

        if (user.is_b2b) {
            setCookie("is_b2b", user.is_b2b);
        }

        const user_profile = await dispatch(setUserProfile());
        dispatch(getPromoMessages());
        window.dataLayer.push({
            'event': 'loginsuccess',
        })
        if (!fromTyPage) {
            if(getLocalCartId()){
                await dispatch(mergeShopifyCartItems());
            } else {
                dispatch(setShopifyCart())
            }
            dispatch(getPromoBanners());
            dispatch(getVaultItems());
        }
        flagsmith.identify(getCookie('flagsmithIdentity'), {email_address: userEmail, personalization_features: user_profile ? user_profile.personalization_features : false}).then(() => {
            window.dataLayer.push({
                'event': 'flagsmith_identify',
                'personalization_enabled':  user_profile && user_profile.personalization_features ? "enabled" : "not_qualified",
            })
        });
        if(hostname === config.host_rebag_shop){
            axios.get(multipass_url, { withCredentials: true })
              .catch((error) => {
                  appErrorLogger('Login with multipass failed', error);
              })
              .then(() => {
                  window.rebagHeader.reactAuthVisual(user);
              })
              .then(() => {
                  if(_.isFunction(window.next_action)){
                      window.next_action();
                  }
                  delete(window.next_action);
                  if(window.location.href.includes('refer')){
                      window.location.reload();
                  }
                  window.dispatchEvent(new CustomEvent('afterLogin'));
              })
        } else {
            window.rebagHeader.reactAuthVisual(user);
            if(urlParams.has('next')){
                window.location = hostname + urlParams.get('next');
            } else if(window.location.href.includes('refer')){
                window.location.reload();
            }
            if(_.isFunction(window.next_action)){
                window.next_action();
            }

            delete(window.next_action);
        }
        resolve();
    })
}

const forgotPassword = (email) => {
    return (dispatch, _) => {
        const data = {
            "email": email,
        };

        axios.post(`${config.host_rebag_api}/v6/reset_password`, data, { withCredentials: true })
            .then((response) => {
                const {error} = response.data;
                if(error) {
                    window.rebagHeader.reactLoginError(error.message);
                } else {
                    window.dataLayer.push({"event":"resetPassword"});
                    window.rebagHeader.reactAuthVisual(null);
                }
            })
            .catch(function (error) {
                window.rebagHeader.reactLoginError("Something went wrong, please try again later.");
                appErrorLogger('Forgot pass failed', error);
            });
    }
}

const setSelectedCountry = () => {
    return (dispatch, getState) => {
        return new Promise (async (resolve) => {
            const availableCountries = getState().appReducer.availableCountries;
            const filteredCountry = availableCountries.find(item => item.isoCode === 'US');
            dispatch(setInternationalStatus(filteredCountry));
            setCookie('selectedCountry', filteredCountry);
            dispatch({
              type: 'SET_SELECTED_COUNTRY',
              payload: filteredCountry,
            });
            const countryEvent = new CustomEvent('selectedCountry', {
              detail: {
                country: filteredCountry
              }
            });
            window.dispatchEvent(countryEvent);
            resolve();
        })
    }
}

const setInternationalStatus = (country) => {
    if (country && country.isoCode !== 'US') {
        return {
            type: 'SET_INTERNATIONAL_STATUS',
            payload: {
                isInternational: true,
                isUsdInternational: country.currency?.isoCode === 'USD'
            }
        }
    } else {
        return {
            type: 'SET_INTERNATIONAL_STATUS',
            payload: {
                isInternational: false,
                isUsdInternational: false,
            }
        }
    }
}

const setEmailConfirmationCode = (force_resend = false) => {
    return (dispatch, getState) => {
        const data = {
            'force_resend': force_resend
        }

        authenticatedAxios().post(`${config.host_rebag_api}/v6/verify-email/`, data)
            .then((response) => {
                dispatch({
                    type: 'SHOW_EMAIL_VALIDATION',
                    show_email_validation: true,
                    show_email_validation_success: false,
                    show_email_validation_error: false,
                    email_validation_error_message: ''
                })
            })
            .catch((error) => {
                dispatch({
                    type: 'SHOW_EMAIL_VALIDATION',
                    show_email_validation: true,
                    show_email_validation_success: false,
                    email_validation_error_message: error.response.data.detail
                })
                appErrorLogger('App setEmailConfirmationCode', error)
            })
    }
}

const validateEmailConfirmationCode = (code) => {
    return (dispatch, getState) => {
        const data = {
            'code': code,
        }

        authenticatedAxios().post(`${config.host_rebag_api}/v6/verify-email/`, data)
            .then((response) => {
                dispatch({
                    type: 'SHOW_EMAIL_VALIDATION',
                    show_email_validation: false,
                    show_email_validation_success: true,
                    show_email_validation_error: false,
                    email_validation_error_message: ''
                })
            })
            .catch((error) => {
                dispatch({
                    type: 'SHOW_EMAIL_VALIDATION',
                    show_email_validation: true,
                    show_email_validation_success: false,
                    email_validation_error_message: error.response.data.detail
                })
                appErrorLogger('App validateEmailConfirmationCode', error)
            })
    }
}

const submitWholesalePartnerForm = (data) => {
    return (dispatch, _) => {
        authenticatedAxios().post(`wholesale-form-submission/`, data)
            .then((response) => {
                window.location = '/wholesale-partner/thank-you';
            })
            .catch((errors) => {
                appErrorLogger('Submit Wholesale Partner Form', errors)
            })
    }
}

const submitPartnerLeadForm = (data, setPartnerCode, setServerError) => {
    return (dispatch, _) => {
        dispatch({type: "SHOW_SPINNER"});
        authenticatedAxios().post(`create-partner/`, data)
            .then((response) => {
                setPartnerCode(response.data.blm_partner_code);
            })
            .catch((errors) => {
                if (errors.response?.data?.detail) {
                    setServerError(errors.response.data.detail.replaceAll("[", "").replaceAll("]", "").replaceAll("'", ""));
                } else {
                    setServerError("Something went wrong. Please try again or contact support.");
                }
                appErrorLogger('Submit Partner Lead Form', errors)
            })
            .finally(() => {
                dispatch({type: "HIDE_SPINNER"});
            })
    }
}

const setStickyFooterElement = (payload) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'SET_STICKY_FOOTER_ELEMENT',
            payload,
        })
    }
}

const getLeadsFormStores = (callback) => {
    return (dispatch, _) => {
        axios.get(`${config.host_rebag_api}/v6/locations-for-partner-form/`)
            .then((response) => {
                callback(response.data);
            })
            .catch(function (error) {
                appErrorLogger('get lead partner form stores', error)
            });
    }
};

const subscribeOptin = (data) => {
    return (dispatch, _) => {
        axios.get(`${config.host_rebag_api}/v6/register/subscriptions/`, {params: data})
            .then((response) => {
                const {sms_subscribed, email_subscribed} = response.data;
                dispatch({
                    type: "SIGNUP_STEP1",
                    is_first_step: false,
                    sms_subscribed: sms_subscribed,
                    email_subscribed: email_subscribed
                });
            })
            .catch(function (error) {
                appErrorLogger('Get Subscriptions', error);
            })
            .finally(() => {
                dispatch(hideModalSpinner());
            })
    }
}

const setNewsletterSuppress = (suppress_newsletter_modal) => {
    return (dispatch) => {
        dispatch({
            type: "NEWSLETTER_SUPPRESS",
            payload: suppress_newsletter_modal,
        });
    }
};

export {
    noScroll,
    getMobileBp,
    getPromoBanners,
    openLoginModal,
    closeLoginModal,
    userLoggedIn,
    userLoggedOut,
    showModalSpinner,
    hideModalSpinner,
    signupSuccess,
    showSpinner,
    hideSpinner,
    getHomeDataDetails,
    forceLogout,
    logout,
    login,
    socialLogin,
    signup,
    forgotPassword,
    getVaultItems,
    getShopifyDataFromFavoriteList,
    getForYouHomepageData,
    isMobile,
    newsletterSignup,
    getPromoMessages,
    filterPromoMessages,
    socialError,
    renderLogoutPopup,
    dismissLogoutPopup,
    trackDataEvents,
    setSelectedCountry,
    setEmailConfirmationCode,
    validateEmailConfirmationCode,
    submitWholesalePartnerForm,
    setStickyFooterElement,
    submitPartnerLeadForm,
    getLeadsFormStores,
    subscribeOptin,
    setNewsletterSuppress,
}